import { inject } from '@angular/core';
import { HttpXsrfTokenExtractor } from '@angular/common/http';
import type { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import type { Observable } from 'rxjs';

export const restXsrfInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const headerName = 'X-XSRF-TOKEN';
  const token = inject(HttpXsrfTokenExtractor).getToken();
  if (token !== null && req.headers !== undefined && !req.headers.has(headerName)) {
    req = req.clone({ headers: req.headers.set(headerName, token) });
  }
  return next(req);
};
